import React, { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { AxiosPost } from "../../../../../context/UserContext";
import { pushNotify } from "../../../../../services/NotifyService";
import { useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment";
import CreatableSelect from 'react-select/creatable';

function LodgingLogsTable() {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
    const [lodgeLogs, setLodgeLogs] = useState([]);
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    const [gridRef, setGridRef] = useState(null)
    const initialFormData = {
        shoot_date: moment().format("YYYY-MM-DD"), activity_type: 'shoot', room_type: 'AC', room_no: "", names: "", department: '',
        check_in: '', check_out: '', room_price: '', remarks: '', hotel_name: '', total_price: ""
    }
    const [formData, setFormData] = useState([initialFormData])
    window.moment = moment
    const [customsl, setCustomSl] = useState('0')
    const [isLoading2, setIsLoading2] = useState(false)
    const [departmentOptions, setDepartmentOptions] = useState([{ label: "Fetching please Wait...", value: "-1" }])


    const filterValue = [
        { name: 'hotel_name', operator: 'startsWith', type: 'string', value: '' },
        { name: 'names', operator: 'startsWith', type: 'string', value: '' },
        { name: 'department', operator: 'startsWith', type: 'string', value: '' },
        { name: 'shoot_date', operator: 'after', type: 'date', value: '' },
        { name: 'activity_type', operator: 'eq', type: 'select', value: null },
        { name: 'room_type', operator: 'startsWith', type: 'string', value: '' },
        { name: 'remarks', operator: 'startsWith', type: 'string', value: '' },
    ];

    const shoot_options = [
        { id: "shoot", label: "shoot" },
        { id: "non-shoot", label: "non-shoot" }
    ]

    const fetchDepartments = async () => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('fetch_department_options.php', formData);
            if (data.success) {
                setDepartmentOptions(data.options)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }

    const columns = [
        { name: 'num_row', header: 'sl', minWidth: 50, editable: false },
        { name: 'hotel_name', header: 'Hotel Name', minWidth: 150 },
        { name: 'names', header: 'Names', minWidth: 150 },
        {
            name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date', minWidth: 150,
            dateFormat: 'YYYY-MM-DD',
            filterEditor: DateFilter,
        },
        {
            name: 'activity_type', defaultFlex: 2, header: 'Activity Type', filterEditor: SelectFilter, minWidth: 150,
            filterEditorProps: {
                placeholder: 'All',
                dataSource: shoot_options
            },
        },
        { name: 'department', defaultFlex: 2, header: 'Department', minWidth: 150 },
        { name: 'room_number', defaultFlex: 2, header: 'Room Number', minWidth: 150 },
        { name: 'room_type', defaultFlex: 2, header: 'Room Type', minWidth: 150 },
        { name: 'check_in', defaultFlex: 2, header: 'Check In', minWidth: 150 },
        { name: 'check_out', defaultFlex: 2, header: 'Check Out', minWidth: 150 },
        { name: 'room_price', defaultFlex: 2, header: 'Room Price', minWidth: 150 },
        { name: 'total_price', defaultFlex: 2, header: 'Total Price', minWidth: 150 },
        { name: 'remarks', defaultFlex: 2, header: 'Remarks', minWidth: 150, editable: false },
        {
            name: 'sl', defaultFlex: 2, header: 'Actions',
            render: ({ value }) =>
                <button className="btn btn-sharp" style={{ color: "red" }} onClick={() => showDeleteForm(value)}><i class="fas fa-trash-alt"></i></button>
        },
    ];


    const handleCreate4 = async (inputValue) => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('add_department_option.php', { name: inputValue });
            if (data.success) {
                await fetchDepartments()
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchDepartments()
        fetchLogsData()
    }, [])

    const fetchLogsData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('fetch_lodge_logs.php')
            if (data.success) {
                setLodgeLogs(data.logs)
                setCustomSl(data.logs.length)
            }
            else pushNotify("error", "Error", data.error)
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const showDeleteForm = (index) => {
        setDeleteModal({ show: true, id: index });
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('delete_lodge_log.php', { sl: deleteModal.id })
            console.log(data);
            if (data.success) pushNotify('success', 'Success', 'Item Deleted Successfully');
            else pushNotify('error', 'Error', data.error);
            setDeleteModal({ show: false, id: null });
            await fetchLogsData();
            console.log(data);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ show: false, id: null });
    }

    const onChangeHandler = (e, index) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        setFormData(old)
    }

    const addLodgeLog = async (e) => {
        e.preventDefault()
        try {
            console.log(formData)
            const data = await AxiosPost('add_lodge_log.php', formData)
            console.log(data);
            if (data.success) {
                setFormData([initialFormData])
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const removeRow = (i) => {
        let old = []
        formData.map((data, index) => index == i ? null : old.push(data))
        setFormData(old)
    }

    const datechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].shoot_date = e.target.value
        })
        setFormData(old)
    }

    const typechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].activity_type = e.target.value
        })
        setFormData(old)
    }

    const onEditComplete = async (e) => {
        try {
            setIsLoading(true)
            let formData = { ...e.data, [e.columnId]: e.value }
            const data = await AxiosPost('update_lodging_logs.php', formData)
            if (data.success) {
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    function getNumber(value) {
        const num = parseInt(value);
        return isNaN(num) ? 0 : num;
    }

    const calcTotal = (e, index, name) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        if (formData[index].check_in !== "" && formData[index].check_out !== "" && formData[index].room_price !== "") {
            if (name == "in") {
                let date1 = new Date(formData[index].check_out)
                let date2 = new Date(e.target.value)
                old[index].total_price = Math.floor(Math.abs(date1 - date2) / (36e5*24)) * getNumber(formData[index].room_price)

            }
            if (name == "out") {
                let date1 = new Date(e.target.value)
                let date2 = new Date(formData[index].check_in)
                old[index].total_price = Math.floor(Math.abs(date1 - date2) / (36e5*24))* getNumber(formData[index].room_price)
            }
            if (name == "price") {
                let date1 = new Date(formData[index].check_out)
                let date2 = new Date(formData[index].check_in)
                old[index].total_price = Math.floor(Math.abs(date1 - date2) / (36e5*24)) * getNumber(e.target.value)
            }
        }
        setFormData(old)
    }

    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div>
                {
                    isLoading ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                        <form className='custom-form-wrapper mb-2' onSubmit={(e) => addLodgeLog(e)}>
                            <div className="custom-form-inner">
                                <div className='custom-form-cell'>
                                    <div className='custom-form-label'>
                                        Shoot Date <span className="text-danger">*</span>
                                    </div>
                                    <div className='custom-form-input'>
                                        <input type="date" value={formData[0].shoot_date} name="shoot_date" onChange={(e) => { datechangehandler(e) }} required />
                                    </div>
                                </div>
                                <div className='custom-form-cell'>
                                    <div className='custom-form-label'>
                                        Activity Type
                                    </div>
                                    <div className='custom-form-input'>
                                        <select value={formData[0].activity_type} name="activity_type" onChange={(e) => typechangehandler(e)} >
                                            <option value="shoot">Shoot</option>
                                            <option value="non-shoot">Non Shoot</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {
                                formData.map((data, index) => (
                                    <div className='custom-form-inner'>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Sl
                                                <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); setFormData([...formData, { ...initialFormData, shoot_date: formData[0].shoot_date, activity_type: formData[0].activity_type }]) }} ><i className="fas fa-plus"></i></button>
                                                {index == 0 ? null : <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); removeRow(index) }} ><i className="fas fa-minus"></i></button>}
                                            </div>
                                            <div className='custom-form-input'>
                                                <div className="form-control">{customsl + index + 1}</div>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Hotel Name <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].hotel_name} name="hotel_name" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Room Type
                                            </div>
                                            <div className='custom-form-input'>
                                                <select value={formData[index].room_type} name="room_type" onChange={(e) => onChangeHandler(e, index)} >
                                                    <option value="AC">AC</option>
                                                    <option value="non-ac">Non-Ac</option>
                                                    <option value="house">House</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Room Number <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].room_no} name="room_no" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Names <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].names} name="names" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Department <span className="text-danger">*</span>
                                            </div>
                                            <div className="custom-form-input">
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "department": e }; setFormData(old) }}
                                                    options={departmentOptions}
                                                    value={formData[index].department}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { handleCreate4(e); let temp = [...formData]; temp[index].department = { value: e, label: e }; setFormData(temp) }}
                                                />

                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Check In <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="date" value={formData[index].check_in} name="check_in" onChange={(e) => { calcTotal(e, index, "in") }} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Check Out <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="date" value={formData[index].check_out} name="check_out" onChange={(e) => { calcTotal(e, index, "out") }} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Room Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].room_price} name="room_price" onChange={(e) => { calcTotal(e, index, "price") }} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Total Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].total_price} name="total_price" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Remarks
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].remarks} name="remarks" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                            <Button className="mt-2 mb-2">
                                Add Lodging Log
                            </Button>
                        </form>
                }

            </div>

            <>
                <Button onClick={fetchLogsData}>
                    Sync Data
                </Button>
                <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                    Export CSV
                </Button>
                <ReactDataGrid
                    idProperty="id"
                    style={gridStyle}
                    columns={columns}
                    pagination="local"
                    dataSource={lodgeLogs}
                    defaultLimit={25}
                    defaultFilterValue={filterValue}
                    handle={setGridRef}
                    editable={true}
                    onEditComplete={onEditComplete}
                    loading={isLoading}
                />
            </>
            <Modal className="fade" show={deleteModal.show} centered>
                <Modal.Header>
                    <Modal.Title>Delete Log?</Modal.Title>
                    <button
                        onClick={cancelDelete}
                        className="btn-close"
                    >
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Are you sure you want to delete the Log?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={deleteItem}
                        className="btn btn-danger"
                    >
                        Delete
                    </button>
                    <button className="btn btn-primary" onClick={cancelDelete}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default LodgingLogsTable;